export default "__VITE_ASSET__CzC0Ubq1__"